import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import TreeItem from "./TreeItem";

type Props = {
  list: {
    id: string | number;
    name: string;
    code: string;
  }[];
  selectedItems: {
    id: string | number;
    name: string;
    code: string;
  }[];
  setSelectedItems: $TSFixMeFunction;
  disabled?: boolean;
  showIsEndress?: boolean;
};

function Tree({
  list,
  selectedItems,
  setSelectedItems,
  disabled = false,
  showIsEndress = false,
}: Props) {
  const [tree, setTree] = useState([]);

  function cleanupNonExistingParents(items: $TSFixMe) {
    const itemIds = new Set(items.map((item: $TSFixMe) => item.id));
    return items.map((item: $TSFixMe) => {
      const correctedParent = { ...item };
      if (correctedParent.parent) {
        const parentId = correctedParent.parent.id;
        if (!itemIds.has(parentId)) {
          delete correctedParent.parent;
        }
      }
      return correctedParent;
    });
  }

  function calculateTree(items: $TSFixMe, parentId = null) {
    return items
      .filter(
        (item: $TSFixMe) => (item.parent ? item.parent.id : null) === parentId,
      )
      .map((item: $TSFixMe) => ({
        ...item,
        children: calculateTree(items, item.id),
      }));
  }

  useEffect(() => {
    const updatedList = cleanupNonExistingParents(list);
    const updatedTree = calculateTree(updatedList);
    setTree(updatedTree);
  }, [list]);

  const addSelectedItem = (item: $TSFixMe) =>
    setSelectedItems((prevState: $TSFixMe) => [...prevState, item]);

  const removeSelectedItem = (item: $TSFixMe) =>
    setSelectedItems((prevState: $TSFixMe) =>
      prevState.filter(
        (selectedItem: $TSFixMe) => selectedItem.code !== item.code,
      ),
    );

  const selectChildren = (item: $TSFixMe, isSelected: $TSFixMe) => {
    item.children.forEach((child: $TSFixMe) => {
      const isChildSelected = !!selectedItems.find(
        (i) => i.code === child.code,
      );
      if (isSelected && isChildSelected) {
        removeSelectedItem(child);
      } else if (!isSelected && !isChildSelected) {
        addSelectedItem(child);
      }

      if (child.children.length > 0) selectChildren(child, isSelected);
    });
  };

  const handleOnChange = (treeItem: $TSFixMe) => {
    const isSelected = !!selectedItems.find((i) => i.code === treeItem.code);
    selectChildren(treeItem, isSelected);
    if (isSelected) {
      removeSelectedItem(treeItem);
    } else addSelectedItem(treeItem);
  };

  return (
    <ul className={`tree ${disabled ? "disabled" : ""}`}>
      {tree.map((item) => (
        <TreeItem
          key={`root-tree-item-${(item as $TSFixMe).id}`}
          treeItem={item}
          onChange={handleOnChange}
          selectedItems={selectedItems}
          disabled={disabled}
          showIsEndress={showIsEndress}
        />
      ))}
      {tree.length === 0 && (
        <li className="no-search-results-text">
          <FormattedMessage id="search.no_results_found" />
        </li>
      )}
    </ul>
  );
}

export default Tree;
